import { render, staticRenderFns } from "./SectionMenuCompany.vue?vue&type=template&id=8bc591c0&"
import script from "./SectionMenuCompany.vue?vue&type=script&lang=js&"
export * from "./SectionMenuCompany.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenuCompany.vue?vue&type=style&index=0&id=8bc591c0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports